import React from 'react';

const ContactForm = (props) => {
  return (
    <div>
      { props.formSubmitError && <div className="alert alert-danger">Error: I'm sorry there has been an error sending your request. If the problem persists please email me directly at <a style={{ color: "#333" }} href="mailto:edward@myvagrantlife.com">edward@myvagrantlife.com</a></div> }
      { props.formSending && <div className="alert alert-info">Sending...</div> }
      { props.formSubmitSuccess && <div className="alert alert-success">Thank you for you contact enquiry. Your message has been sent successfully.</div> }

      { !props.formSubmitError && !props.formSending && !props.formSubmitSuccess &&
        <form id="contactform" onSubmit={props.submitForm} method="POST">
          <input type="text" name="name" placeholder="*Name" required onChange={props.onFormChange} />
          <input type="email" name="email" placeholder="*Email" required onChange={props.onFormChange} />
          <textarea name="message" placeholder="*Message" required onChange={props.onFormChange}></textarea>
          <input type="hidden" name="_subject" value="Website Contact - Edward Smith Photography" />
          <input type="text" name="_gotcha" style={{display:'none'}} onChange={props.onFormChange} />
          <input type="submit" value="Submit" disabled={props.formSending} />
        </form>
      }
    </div>
  );
};

export default ContactForm;



// WEBPACK FOOTER //
// ./src/components/forms/ContactForm.js